import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as echarts from 'echarts';
import axios from 'axios';
import dayjs from 'dayjs';
import m3u8Video from '@/components/m3u8Video';
export default {
  components: {
    m3u8Video: m3u8Video
  },
  data: function data() {
    return {
      dayjs: dayjs,
      device_list: [],
      active: 0,
      lastData: {
        w_t: {
          name: '温度',
          unit: '℃'
        },
        w_o: {
          name: '溶解氧',
          unit: 'mg/L'
        },
        w_PH: {
          name: 'PH',
          unit: ''
        },
        w_TSS: {
          name: '浊度',
          unit: 'NTU'
        }
      },
      deviceState: {},
      overview_data: {},
      meter_list: [{
        deviceName: '鼓风机',
        iaLatestValue: 1.52,
        ibLatestValue: 1.48,
        icLatestValue: 1.5,
        lineData: {
          a: [1.52, 1.49, 1.51, 1.5, 1.52, 1.51, 1.49, 1.53, 1.5, 1.52],
          b: [1.49, 1.46, 1.48, 1.47, 1.48, 1.48, 1.46, 1.49, 1.47, 1.48],
          c: [1.51, 1.48, 1.5, 1.49, 1.5, 1.5, 1.48, 1.51, 1.49, 1.5]
        }
      }, {
        deviceName: '增氧机',
        iaLatestValue: 1.61,
        ibLatestValue: 1.57,
        icLatestValue: 1.59,
        lineData: {
          a: [1.6, 1.62, 1.59, 1.61, 1.6, 1.61, 1.59, 1.62, 1.6, 1.61],
          b: [1.56, 1.58, 1.55, 1.57, 1.56, 1.57, 1.55, 1.58, 1.56, 1.57],
          c: [1.58, 1.6, 1.57, 1.59, 1.58, 1.59, 1.57, 1.6, 1.58, 1.59]
        }
      }, {
        deviceName: '投饲机',
        iaLatestValue: 8.62,
        ibLatestValue: 8.55,
        icLatestValue: 8.59,
        lineData: {
          a: [8.64, 8.56, 8.61, 8.57, 8.63, 8.6, 8.55, 8.65, 8.58, 8.62],
          b: [8.57, 8.5, 8.54, 8.51, 8.56, 8.54, 8.5, 8.58, 8.52, 8.55],
          c: [8.6, 8.53, 8.58, 8.54, 8.59, 8.57, 8.53, 8.61, 8.56, 8.59]
        }
      }, {
        deviceName: '制冷机',
        iaLatestValue: 7.48,
        ibLatestValue: 7.42,
        icLatestValue: 7.45,
        lineData: {
          a: [7.49, 7.45, 7.48, 7.44, 7.46, 7.47, 7.43, 7.5, 7.45, 7.48],
          b: [7.43, 7.4, 7.42, 7.39, 7.4, 7.41, 7.39, 7.44, 7.4, 7.42],
          c: [7.46, 7.43, 7.45, 7.42, 7.43, 7.44, 7.41, 7.47, 7.43, 7.45]
        }
      }],
      dialogVisible: false,
      meterData: {},
      meterId: '',
      meter_daterange: [dayjs().subtract(1, "hour").format('YYYY-MM-DD HH:mm:ss'), dayjs().format('YYYY-MM-DD HH:mm:ss')] //单设备电流时间范围选择
      ,
      meterDailyenergy_count: 0,
      playUrl: '',
      feed_logs: [],
      feedLogs: [{
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 65,
        number: 2,
        logs: []
      }]
      // 查看生产报告
      ,
      searchForm: {
        page: 1,
        limit: 10,
        sortField: 'report_date'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      pupopShow: false,
      reportDetail: {},
      dialogShow: false,
      labInfo: localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')) : {},
      show: true,
      video1: '2088631109191892992',
      video1_list: [],
      video2: '2088631496238071808',
      video2_list: [],
      videoId: '',
      videoShow: false,
      price_params: {
        labId: localStorage.getItem('labId'),
        sortField: 'report_date',
        page: 1,
        limit: -1
      },
      price_list: [],
      mockValue: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    console.log('labInfo', this.labInfo);
    this.getDeviceList();
    this.getPriceList();
    this.getVideoList();
    this.$nextTick(function () {
      _this.getfeedLogs();
      _this.getmarketPrice();
    });
    var stepMap = {
      '水温': 1.5,
      '溶解氧': 0.5,
      '酸碱度': 0.3
    };
    this.timer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var index, lastData, _loop, key;
      return _regeneratorRuntime().wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = _regeneratorRuntime().keys(_this.device_list);
          case 1:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 21;
              break;
            }
            index = _context2.t1.value;
            if (!_this.device_list[index].smartControlId) {
              _context2.next = 9;
              break;
            }
            _context2.next = 6;
            return _this.getDeviceLastRecord(_this.device_list[index].smartControlId);
          case 6:
            _context2.t2 = _context2.sent;
            _context2.next = 10;
            break;
          case 9:
            _context2.t2 = {};
          case 10:
            lastData = _context2.t2;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(key) {
              var name, step;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    name = lastData[key].name;
                    step = stepMap[name] || 0.5;
                    lastData[key].forecastValues = Array.from({
                      length: 4
                    }, function () {
                      return _this.getRandomFloat(lastData[key].itemValue - step, lastData[key].itemValue + step, 1);
                    });
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _loop);
            });
            _context2.t3 = _regeneratorRuntime().keys(lastData);
          case 13:
            if ((_context2.t4 = _context2.t3()).done) {
              _context2.next = 18;
              break;
            }
            key = _context2.t4.value;
            return _context2.delegateYield(_loop(key), "t5", 16);
          case 16:
            _context2.next = 13;
            break;
          case 18:
            _this.$set(_this.device_list[index], 'lastData', lastData);
            _context2.next = 1;
            break;
          case 21:
            console.log('this.device_list', _this.device_list);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    })), 20000);
  },
  watch: {
    show: function show(to) {
      var _this2 = this;
      if (to) {
        this.$nextTick(function () {
          _this2.ChartInit();
          _this2.getmarketPrice();
        });
      }
    },
    video1: {
      handler: function handler(val) {
        var _this3 = this;
        if (val === '8号水上' && !this._mockStarted) {
          this._mockStarted = true;
          this.mockValue = 6.2;
          setTimeout(function () {
            _this3._mockTimer = setInterval(function () {
              if (_this3.mockValue < 9.21) {
                _this3.mockValue = Math.round((_this3.mockValue + 0.15) * 100) / 100;
                if (_this3.mockValue >= 9.21) {
                  _this3.mockValue = 9.21;
                  clearInterval(_this3._mockTimer);
                }
              }
            }, 10000);
          }, 60000);
        }
      },
      immediate: true
    }
  },
  computed: {
    mockData: function mockData() {
      return this.mockValue.toFixed(2);
    }
  },
  destroyed: function destroyed() {
    this.echart4 && this.echart4.dispose();
    this.myChart1 && this.myChart1.dispose();
    this.myChart2 && this.myChart2.dispose();
    this.timer && clearInterval(this.timer);
    this._mockTimer && clearInterval(this._mockTimer);
  },
  methods: {
    backClick: function backClick() {
      // this.$router.back()
      this.$router.replace('/index');
    },
    getVideoList: function getVideoList() {
      var _this4 = this;
      this.$api.videoQuery({
        labId: localStorage.getItem('labId'),
        page: 1,
        limit: -1,
        videoType: 'WATER_UP',
        sortField: 'lab_id,^sort'
      }).then(function (res) {
        _this4.video1_list = res.data || [];
        _this4.video1_list.push({
          videoName: '7号水上',
          id: '7号水上'
        }, {
          videoName: '8号水上',
          id: '8号水上'
        });
      });
      this.$api.videoQuery({
        labId: localStorage.getItem('labId'),
        page: 1,
        limit: -1,
        videoType: 'WATER_DOWN',
        sortField: 'lab_id,^sort'
      }).then(function (res) {
        _this4.video2_list = res.data || [];
        _this4.video2_list.push({
          videoName: '9号水下',
          id: '9号水下'
        });
      });
    },
    getRandomFloat: function getRandomFloat(min, max) {
      var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
      console.log('getRandomFloat', min, max, decimals = 2);
      var random = Math.random() * (max - min) + min;
      return Math.round(random * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },
    getPriceList: function getPriceList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, chunkArray;
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this5.$api['marketSpecPriceQuery'](_this5.price_params);
            case 2:
              res = _context3.sent;
              chunkArray = function chunkArray(arr) {
                var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
                return Array.from({
                  length: Math.ceil(arr.length / size)
                }, function (_, i) {
                  return arr.slice(i * size, i * size + size);
                });
              };
              _this5.price_list = chunkArray(res.data || []);
              // console.log('price_list',this.price_list)
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee2);
      }))();
    },
    getDeviceList: function getDeviceList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, index, lastData, stepMap, _iterator, _step, _loop2;
        return _regeneratorRuntime().wrap(function _callee3$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.$api['labAreaQuery']({
                labId: localStorage.getItem('labId'),
                sortField: '^sort',
                searchKey: 'Cistern,Pond,Lake',
                page: 1,
                limit: 4
              });
            case 2:
              res = _context6.sent;
              _this6.device_list = res.data || [];
              _context6.t0 = _regeneratorRuntime().keys(res.data);
            case 5:
              if ((_context6.t1 = _context6.t0()).done) {
                _context6.next = 18;
                break;
              }
              index = _context6.t1.value;
              if (!res.data[index].smartControlId) {
                _context6.next = 13;
                break;
              }
              _context6.next = 10;
              return _this6.getDeviceLastRecord(res.data[index].smartControlId);
            case 10:
              _context6.t2 = _context6.sent;
              _context6.next = 14;
              break;
            case 13:
              _context6.t2 = {};
            case 14:
              lastData = _context6.t2;
              _this6.$set(_this6.device_list[index], 'lastData', lastData);
              _context6.next = 5;
              break;
            case 18:
              _this6.device_list.push({
                name: '一期9号池',
                id: '9号养殖池',
                lastData: {
                  "item_aa": {
                    "name": "水温",
                    "unit": "℃",
                    "predict": [],
                    "itemValue": 17.21,
                    "level": "良"
                  },
                  "item_ab": {
                    "name": "溶解氧",
                    "unit": "mg/L",
                    "predict": [],
                    "itemValue": 6.2,
                    "level": "优"
                  },
                  "item_ac": {
                    "name": "酸碱度",
                    "unit": "pH",
                    "predict": [],
                    "itemValue": 7.13,
                    "level": "优"
                  }
                }
              });
              stepMap = {
                '水温': 1.5,
                '溶解氧': 0.5,
                '酸碱度': 0.3
              };
              _iterator = _createForOfIteratorHelper(_this6.device_list);
              _context6.prev = 21;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var item, _loop3, key;
                return _regeneratorRuntime().wrap(function _loop2$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      item = _step.value;
                      _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3(key) {
                        var name, step;
                        return _regeneratorRuntime().wrap(function _loop3$(_context4) {
                          while (1) switch (_context4.prev = _context4.next) {
                            case 0:
                              name = item.lastData[key].name;
                              step = stepMap[name] || 0.5;
                              item.lastData[key].forecastValues = Array.from({
                                length: 4
                              }, function () {
                                return _this6.getRandomFloat(item.lastData[key].itemValue - step, item.lastData[key].itemValue + step, 1);
                              });
                            case 3:
                            case "end":
                              return _context4.stop();
                          }
                        }, _loop3);
                      });
                      _context5.t0 = _regeneratorRuntime().keys(item.lastData);
                    case 3:
                      if ((_context5.t1 = _context5.t0()).done) {
                        _context5.next = 8;
                        break;
                      }
                      key = _context5.t1.value;
                      return _context5.delegateYield(_loop3(key), "t2", 6);
                    case 6:
                      _context5.next = 3;
                      break;
                    case 8:
                    case "end":
                      return _context5.stop();
                  }
                }, _loop2);
              });
              _iterator.s();
            case 24:
              if ((_step = _iterator.n()).done) {
                _context6.next = 28;
                break;
              }
              return _context6.delegateYield(_loop2(), "t3", 26);
            case 26:
              _context6.next = 24;
              break;
            case 28:
              _context6.next = 33;
              break;
            case 30:
              _context6.prev = 30;
              _context6.t4 = _context6["catch"](21);
              _iterator.e(_context6.t4);
            case 33:
              _context6.prev = 33;
              _iterator.f();
              return _context6.finish(33);
            case 36:
              console.log('this.device_list', _this6.device_list[0], JSON.stringify(_this6.device_list[0]));
            case 37:
            case "end":
              return _context6.stop();
          }
        }, _callee3, null, [[21, 30, 33, 36]]);
      }))();
    } // 环境数据
    ,
    getDeviceLastRecord: function getDeviceLastRecord(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, lastData, predictionData, res1, _iterator2, _step2, item, res2, key;
        return _regeneratorRuntime().wrap(function _callee4$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.$api['smartControlLastRecord'](id);
            case 2:
              res = _context7.sent;
              lastData = {}, predictionData = [];
              _context7.next = 6;
              return _this7.$api['smartControlItemQuery']({
                smartControlId: id
              });
            case 6:
              res1 = _context7.sent;
              _iterator2 = _createForOfIteratorHelper(res1.data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  lastData[item.typeCode] = {
                    name: item.typeName,
                    unit: item.unit,
                    predict: []
                  };
                  item.predictionCode !== 'Nothing' && predictionData.push({
                    idx: item.typeCode,
                    itemType: item.predictionCode,
                    itemValue: res.data[item.typeCode]
                  });
                }
                // predictionData = [...new Map(predictionData.map(item => [item.idx, item])).values()]
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context7.next = 11;
              return _this7.$api['mathFormulaWaterQualitys'](predictionData);
            case 11:
              res2 = _context7.sent;
              for (key in res.data) {
                if (lastData[key]) {
                  lastData[key].itemValue = Number(res.data[key]);
                  lastData[key].level = res2.data[key];
                }
              }
              return _context7.abrupt("return", lastData);
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee4);
      }))();
    } // 左滚动
    ,
    scrollLeft: function scrollLeft() {
      console.log('左箭头点击了');
      var container = this.$refs.scrollContainer;
      console.log('容器元素：', container);
      console.log('当前 scrollLeft：', container.scrollLeft);
      var step = 120;
      container.scrollLeft = Math.max(0, container.scrollLeft - step);
      console.log('滚动后 scrollLeft：', container.scrollLeft);
    },
    // 右滚动
    scrollRight: function scrollRight() {
      var container = this.$refs.scrollContainer;
      var step = 120;
      // 最大可滚动距离 = 内容总宽 - 容器可见宽
      var maxScroll = container.scrollWidth - container.clientWidth;
      container.scrollLeft = Math.min(maxScroll, container.scrollLeft + step);
    },
    getWaterLevel: function getWaterLevel(data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var val, _iterator3, _step3, item, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              val = [];
              _iterator3 = _createForOfIteratorHelper(data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  item.predictionCode !== 'Nothing' && val.push({
                    idx: val.length,
                    itemType: item.predictionCode,
                    itemValue: item.itemValue
                  });
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _context8.next = 5;
              return _this8.$api['mathFormulaWaterQualitys'](val);
            case 5:
              res = _context8.sent;
              return _context8.abrupt("return", res.data || {});
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee5);
      }))();
    },
    ChartInit: function ChartInit() {
      var xAxisData = [],
        seriesData = [];
      this.feed_logs = this.feedLogs[this.active].logs;
      var _iterator4 = _createForOfIteratorHelper(this.feed_logs),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          xAxisData.unshift(item.time);
          seriesData.unshift(item.weight);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.myChart1 && this.myChart1.dispose();
      var chartDom = document.getElementById('largeHall-chart');
      this.myChart1 = echarts.init(chartDom);
      var option;
      option = {
        textStyle: {
          color: '#fff'
        },
        color: ['rgba(41, 241, 250,0.8)'],
        grid: {
          bottom: 20,
          right: 0,
          left: 0,
          top: 10
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#7C8A91'
            }
          },
          data: xAxisData
        },
        yAxis: {
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.15)'
            }
          },
          type: 'value'
        },
        series: [{
          data: seriesData,
          type: 'line',
          showSymbol: false,
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(37, 123, 198, 1)'
            }, {
              offset: 1,
              color: 'rgba(85, 139, 189, 0)'
            }])
          },
          lineStyle: {
            width: 3,
            shadowColor: 'rgba(0,0,0,0.3)',
            shadowBlur: 10,
            shadowOffsetY: 8,
            color: '#2DAAF3'
          },
          label: {
            show: true,
            color: '#CFDAE6'
          }
        }]
      };
      option && this.myChart1.setOption(option);
    },
    getfeedLogs: function getfeedLogs() {
      this.feedLogs = [{
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 60,
        number: 2,
        logs: []
      }, {
        ammount: 65,
        number: 2,
        logs: []
      }, {
        ammount: 60,
        number: 2,
        logs: []
      }];
      var logs;
      var _iterator5 = _createForOfIteratorHelper(this.feedLogs),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          logs = [];
          for (var i = 1; i < 5; i++) {
            logs.push({
              time: "".concat(dayjs().subtract(i, 'day').format('YYYY-MM-DD'), " 20:0").concat(Math.floor(Math.random() * 10)),
              weight: ((item.ammount + (Math.random() * 10 - 5)) / item.number).toFixed(2)
            });
            logs.push({
              time: "".concat(dayjs().subtract(i, 'day').format('YYYY-MM-DD'), " 09:0").concat(Math.floor(Math.random() * 10)),
              weight: ((item.ammount + (Math.random() * 10 - 5)) / item.number).toFixed(2)
            });
          }
          if (dayjs().valueOf() > dayjs("".concat(dayjs().format('YYYY-MM-DD'), " 09:00:00")).valueOf()) {
            logs.unshift({
              time: "".concat(dayjs().format('YYYY-MM-DD'), " 09:0").concat(Math.floor(Math.random() * 10)),
              weight: ((item.ammount + (Math.random() * 10 - 5)) / item.number).toFixed(2)
            });
          }
          if (dayjs().valueOf() > dayjs("".concat(dayjs().format('YYYY-MM-DD'), " 20:00:00")).valueOf()) {
            logs.unshift({
              time: "".concat(dayjs().format('YYYY-MM-DD'), " 20:0").concat(Math.floor(Math.random() * 10)),
              weight: ((item.ammount + (Math.random() * 10 - 5)) / item.number).toFixed(2)
            });
          }
          item.logs = logs;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.ChartInit();
    } // 用电量概览
    ,
    getOverview: function getOverview() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this9.$api['homePageOverview']({
                startTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                endTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
              });
            case 2:
              res = _context9.sent;
              _this9.overview_data = res.data || {};
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee6);
      }))();
    } // 获取设备排数据
    ,
    getMeter: function getMeter() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 2;
              return _this0.$api['mbmeterList']({
                deviceGroup: _this0.device_list[_this0.active].name
              });
            case 2:
              res = _context0.sent;
              _this0.meter_list = res.data || [];
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee7);
      }))();
    },
    meterClick: function meterClick(data) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _this1.meterData = JSON.parse(JSON.stringify(data));
              _this1.dialogVisible = true;
              _this1.$nextTick(function () {
                _this1.MeterDailyenergyChartInit();
              });
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee8);
      }))();
    },
    MeterDailyenergyChartInit: function MeterDailyenergyChartInit() {
      if (this.myChart2) {
        this.myChart2.dispose();
      }
      var chartDom = document.getElementById('largeHall-lineChart');
      this.myChart2 = echarts.init(chartDom);
      var now = dayjs();
      var minute = now.minute();
      // 获取当前时间之前最近的一个整点或半点半
      var current = now.minute(minute < 30 ? 0 : 30).second(0);
      if (now.isBefore(current)) {
        current = current.subtract(30, 'minute');
      }

      // 向前取10条
      var times = Array.from({
        length: 10
      }, function (_, i) {
        return current.subtract(i * 30, 'minute').format('HH:mm');
      });
      console.log('MeterDailyenergyChartInit', this.meterData, times);
      this.option = {
        xAxis: {
          type: 'category',
          data: [].concat(times).reverse(),
          boundaryGap: false,
          show: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.5)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['A相', 'B相', 'C相'],
          textStyle: {
            color: '#fff'
          }
        },
        color: ['#2B80FF', '#04CDF4', '#FF9D00', '#FFE426', '#D57742'],
        grid: {
          left: 30,
          right: 35,
          bottom: 20,
          top: 40
        },
        textStyle: {
          color: '#fff'
        },
        series: [{
          name: 'A相',
          data: this.meterData.lineData.a,
          type: 'line',
          smooth: true,
          symbolSize: 6,
          symbol: 'circle',
          lineStyle: {
            color: '#04CDF4',
            width: 2
          },
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(4, 205, 244, 0.6)'
            }, {
              offset: 1,
              color: 'rgba(4, 205, 244, 0)'
            }])
          }
        }, {
          name: 'B相',
          data: this.meterData.lineData.b,
          type: 'line',
          smooth: true,
          symbolSize: 6,
          symbol: 'circle',
          lineStyle: {
            color: '#2B80FF',
            width: 2
          },
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(43, 128, 255, 0.6)'
            }, {
              offset: 1,
              color: 'rgba(43, 128, 255, 0)'
            }])
          }
        }, {
          name: 'C相',
          data: this.meterData.lineData.c,
          type: 'line',
          smooth: true,
          symbolSize: 6,
          symbol: 'circle',
          lineStyle: {
            color: '#FF9D00',
            width: 2
          },
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(255, 157, 0, 0.6)'
            }, {
              offset: 1,
              color: 'rgba(255, 157, 0, 0)'
            }])
          }
        }]
      };
      this.option && this.myChart2.setOption(this.option);
    },
    getmarketPrice: function getmarketPrice() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var option, res, xAxisData, seriesData, _iterator6, _step6, item;
        return _regeneratorRuntime().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this10.echart4 = echarts.init(document.getElementById('marketPrice'));
              _context10.next = 3;
              return _this10.$api['marketPriceQuery']({
                page: 1,
                limit: 20,
                sortField: '^report_date',
                labId: localStorage.getItem('labId')
              });
            case 3:
              res = _context10.sent;
              xAxisData = [], seriesData = [];
              _iterator6 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  item = _step6.value;
                  xAxisData.push(item.reportDate);
                  seriesData.push(item.price);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              option = {
                color: ['#06F7A1'],
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 20,
                  top: 10,
                  right: 0,
                  left: 30
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255, 255, 255, 0.15)'
                    }
                  },
                  data: xAxisData
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  }
                },
                series: [{
                  name: '价格分析',
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 3,
                    color: {
                      type: 'linear',
                      x: 1,
                      y: 0,
                      x2: 0,
                      y2: 0,
                      colorStops: [{
                        offset: 0,
                        color: 'rgba(48, 255, 228, 1)' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: 'rgba(6, 247, 161, 1)' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                    }
                  },
                  showSymbol: false,
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(56, 247, 161,0.7)'
                    }, {
                      offset: 1,
                      color: 'rgba(56, 247, 161,0)'
                    }])
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: seriesData
                }]
              };
              _this10.echart4.setOption(option);
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee9);
      }))();
    }
  }
};